<div *ngIf="layoutService.isMobileLayout && sheetIsAvailable" class="openInfoButton">
  <button mat-flat-button (click)="openInfoSheet()">
    <div class="arrow"></div>
  </button>
</div>
<app-mobile-filters></app-mobile-filters>
